import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useFormikContext } from 'formik';
import { FieldValueMapType, FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { PlatformResourceSelector } from 'components/PlatformResourceSelector';
import { useEmbedModelsFromApp } from 'components/PlatformResourceSelector/utils';
import { usePlatformResourceSelector } from 'components/PlatformResourceSelector/usePlatformResourceSelector';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { FormLabel } from './FormLabel';
import { inputContainer, selectStyle, formContainer } from '../../../styles';

type EmbedModelVersionIdFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & { path: string };

export function EmbedModelVersionIdFormElement({ path }: EmbedModelVersionIdFormElementProps): JSX.Element | null {
  const { query } = useRouter() as { query: Record<string, string> };
  const { appId, userOrOrgId } = query;
  const { values, setFieldValue } = useFormikContext();
  const { fieldValueMap } = values as { fieldValueMap: FieldValueMapType<string> };
  const modelId = fieldValueMap[path] || '';
  const { description = '', placeholder = '' } = selectModelTypeFieldTypeInfo(path, values as FormikInitialValues);

  const onChange = useCallback(
    (option) => {
      setFieldValue('fieldValueMap', { ...fieldValueMap, [path]: option.value });
    },
    [fieldValueMap],
  );

  const dataOptions = useEmbedModelsFromApp({ userId: userOrOrgId, appId });
  const prsData = usePlatformResourceSelector(dataOptions, modelId);

  return (
    <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={description} required />
        <div className={selectStyle}>
          <PlatformResourceSelector {...prsData} onChange={onChange} placeholder={placeholder || 'Search Models or enter an ID'} />
        </div>
      </div>
    </div>
  );
}
